export { default } from './CollectionsCarouselTags';
